import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { formatReadSettingsAdapts, FormatReadSettingsAdapter } from './format-read-settings.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { DeltaFormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/delta-format-read-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DeltaFormatReadSettings),
    asynchronous: true,
    adapts: {
        ...formatReadSettingsAdapts,
        timestampAsOf: '*',
        versionAsOf: '*'
    }
})
export class DeltaFormatReadSettingsAdapter extends FormatReadSettingsAdapter<
    DeltaFormatReadSettings,
    Model.DeltaFormatReadSettings
> {
    protected override async _toResource(model: DeltaFormatReadSettings): Promise<Model.DeltaFormatReadSettings> {
        const result: Model.DeltaFormatReadSettings = FormatReadSettingsAdapter.getCommonReadSettingsProperties(
            'DeltaReadSettings'
        ) as Model.DeltaFormatReadSettings;
        
        result.timestampAsOf = ValueAdapter.toResource(model, DeltaFormatReadSettings.TIMESTAMP_AS_OF);
        result.versionAsOf = ValueAdapter.toResource(model, DeltaFormatReadSettings.VERSION_AS_OF);
        
        return result;
    }

    protected override async _toModel(
        resource: Model.DeltaFormatReadSettings,
        copySource: CopySource
    ): Promise<DeltaFormatReadSettings> {
        const result = FormatReadSettingsAdapter.createReadSettingsWithCommonProperties(
            DeltaFormatReadSettings.MODEL,
            copySource
        ) as DeltaFormatReadSettings;
        
        ValueAdapter.toModel(result, DeltaFormatReadSettings.TIMESTAMP_AS_OF, resource.timestampAsOf);
        ValueAdapter.toModel(result, DeltaFormatReadSettings.VERSION_AS_OF, resource.versionAsOf);
        
        return result;
    }
}
